import { Wording } from '@/types';

export const MEDITATION_WORDING_BG: Wording = {
  components_header_media_content: 'аудиозаписи',
  components_header_media_1: 'Медитации',
  components_header_media_2: 'Подкаст',
  components_header_text1: 'Ръководства',
  components_header_text2: 'Блог',
  components_header_members: 'Членове',
  hero_text: 'Където медитацията среща звездите',
  hero_button_text: 'Започнете вашето пътуване навътре',
  components_ressources_section_title: 'РЕСУРСИ',
  components_ressources_subheader_text: 'Инструменти за вътрешен мир, заземяване и ежедневен баланс',
  components_ressources_span_text: 'Отворете вратата към вътрешния мир с нашите подбрани медитации и ръководства. Намерете яснота, свържете се отново с дъха си и се приведете в съответствие с вътрешния си ритъм - момент по момент.',
  components_ressources_card_1_title: 'Отражение',
  components_ressources_card_1_text: 'Кратки медитации и аудиоразмисли, за да центрирате мислите си и да ги приведете в съответствие с космическия си ритъм.',
  components_ressources_card_2_title: 'Изследвайте дълбините',
  components_ressources_card_2_text: 'Пътувайте отвъд повърхността с потапящи водачи, които съчетават медитация, астрология и самоизследване за трайна трансформация.',
  components_ressources_link: 'Вижте повече',
  components_notes_and_google_title_1: 'Душевно напътствие',
  components_notes_and_google_title_2: 'Съзнателни ритуали',
  components_notes_and_google_title_3: 'Водени медитации',
  components_review_google_text: 'Google Рецензии',
  media_content_section_title: 'АУДИО',
  media_content_section_subheader_text: 'Нашите медитации',
  text_media_1: '',
  text_media_2: '',
  media_content_section_button_more: 'Открийте повече',
  text2_section_title: 'БЛОГ',
  text2_section_subheader_text: '',
  text2_section_button_more: '',
  components_text1_section_title: 'РЪКОВОДСТВА',
  components_text1_subheader_text: 'Космическо знание за ежедневно привеждане в съответствие',
  components_text1_span_text: 'Приведете се в съответствие с ритъма на Вселената: изследвайте подбрана колекция от задълбочени астрологични и медитативни ръководства, предназначени да събудят вътрешната яснота, да задълбочат самосъзнанието и да подкрепят вашето пътуване към духовен, небесен растеж.',
  components_text1_card_1_title: 'Отворен към Тишината',
  components_text1_card_1_text: 'Започнете пътуването си с основни ръководства за медитация и астрология – идеални за търсачи, привлечени от вътрешна тишина, космически модели и лично прозрение.',
  components_text1_card_3_title: 'Връзка ум-тяло',
  components_text1_card_3_text: 'Разкрийте по-дълбоките слоеве на вътрешния си свят. Тези ръководства излизат отвъд повърхността, за да разкрият смисъл, емоция и съзнателни модели, които оформят вашето преживяване.',
  components_text1_card_2_title: 'Отразете и интегрирайте',
  components_text1_card_2_text: 'От емоционални блокове до планетарни цикли – тези ръководства предлагат инструменти за размисъл, изцеление и трансформация чрез съзнателни ритуали и астрологична мъдрост.',
  components_text1_link: 'Вижте всички ръководства',
  components_footer_text: 'Събудете се отвътре: Вашата тишина, Вашата сила',
  components_footer_info: 'Информация',
  components_footer_registration_number: 'Регистрационен номер',
  components_footer_legal: 'Законни',
  components_footer_terms: 'Правила и условия',
  components_footer_privacy: 'Политика за поверителност',
  button_load_more: 'Зареди още',
  page_media_1_content_hero_text: 'Медитации',
  page_media_content_menu_antistress: 'Антистрес',
  page_media_content_menu_mindfulness: 'Внимателност',
  page_media_content_menu_energyboost: 'Повишаване на енергията',
  page_media_content_menu_mantra: 'Мантра',
  page_media_2_content_hero_text: '',
  page_text1_hero_text: 'Ръководства',
  page_text1_section_title: 'Ръководства',
  page_text1_subheader_text: 'Нашите водачи',
  page_text2_hero_text: '',
  page_text2_section_title: '',
  page_text2_subheader_text: '',
  enter_email_title: 'Моля, въведете вашия имейл, за да продължите',
  enter_email_placeholder_email: 'Имейл',
  enter_email_button_enter: 'Въведете',
  components_login_success_text: 'Успешно влизане!',
  components_card_link_media_content: 'Слушай сега',
  components_card_link_text1_content: 'Вижте ръководството',
  components_card_link_text2_content: 'Разгледайте',
  france: 'Франция',
  cyprus: 'Кипър',
  tag_podcast: 'Подкаст',
  tag_meditation: 'Медитация',
  page_media_content_menu_all: 'Всички',
};